import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../colorVars';
import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';
import { Body4 } from '../../../../../../atomic/text/Text';
import { OptionData } from '../optionChains/optionType';

type Props = {
  chain: OptionData;
  date: string;
};

export const SelectOptionsModalRow = observer(({ chain, date }: Props) => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const optionManagement = tradePlanForm.optionManagement;
  const selectionMap = optionManagement.optionChainSelectionMap[date];
  return (
    <tr>
      <td>
        <div>
          <input
            type="checkbox"
            checked={selectionMap[chain.symbol]}
            onChange={({ target }) => {
              optionManagement.setOptionChainSelectionMapValue(
                chain.symbol,
                date,
                target.checked
              );
            }}
          />
        </div>
      </td>
      <td>
        <Body4 color={colors.lightGrey}>
          {chain.strike || chain.strike === 0
            ? ApplyRounding(chain.strike, 2)
            : '-'}
        </Body4>
      </td>
      <td>
        <Body4 color={colors.lightGrey}>
          {chain.bid || chain.bid === 0 ? ApplyRounding(chain.bid, 2) : '-'}
        </Body4>
      </td>
      <td>
        <Body4 color={colors.lightGrey}>
          {chain.ask || chain.ask === 0 ? ApplyRounding(chain.ask, 2) : '-'}
        </Body4>
      </td>
      <td>
        <Body4 color={colors.lightGrey}>
          {chain.greeks?.delta || chain.greeks?.delta === 0
            ? ApplyRounding(chain.greeks.delta, 2)
            : '-'}
        </Body4>
      </td>
      <td>
        <Body4 color={colors.lightGrey}>
          {chain.greeks?.theta || chain.greeks?.theta === 0
            ? ApplyRounding(chain.greeks?.theta, 2)
            : '-'}
        </Body4>
      </td>
      <td>
        <Body4 color={colors.lightGrey}>
          {chain.open_interest || chain.open_interest === 0
            ? ApplyRounding(chain.open_interest)
            : '-'}
        </Body4>
      </td>
      <td>
        <Body4 color={colors.lightGrey}>
          {chain.volume || chain.volume === 0
            ? ApplyRounding(chain.volume)
            : '-'}
        </Body4>
      </td>
    </tr>
  );
});
